import { PropsWithChildren } from "react";
import { Unstable_Grid2 as Grid, Grid2Props as GridProps } from "@mui/material";

/**
 * EKPPageGridItem with no padding and a default span of 12 columns
 */
export const EKPPageGridItem = (props: PropsWithChildren<GridProps>) => {
    return (
        <Grid xsMobile={12} p={0} {...props}>
            {props.children}
        </Grid>
    );
};
